export default __webpack_public_path__ + "static/media/Handout.388ce8be.svg";